var _line, _path, _path2, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaninsoftTreeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 174,
    viewBox: "0 0 192 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    x2: 101.5,
    y2: 70,
    stroke: "#CBCBCB",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 0.00390625V28.0039L75 45.0039",
    stroke: "#CBCBCB",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117 0.00390625V28.0039L129 45.0039",
    stroke: "#CBCBCB",
    strokeWidth: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 77.6757,
    y1: 64.2668,
    x2: 89.6757,
    y2: 75.2668,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 112.375,
    y1: 78.223,
    x2: 127.375,
    y2: 66.223,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 154.293,
    y1: 76.711,
    x2: 143.293,
    y2: 65.711,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 175.148,
    y1: 105.528,
    x2: 167.148,
    y2: 92.528,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 168.186,
    y1: 122.644,
    x2: 176.186,
    y2: 111.423,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 141.555,
    y1: 112.172,
    x2: 159.555,
    y2: 124.172,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 141.36,
    y1: 102.236,
    x2: 153.36,
    y2: 92.2357,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 111.64,
    y1: 89.2357,
    x2: 129.64,
    y2: 104.236,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 103,
    y1: 96.0039,
    x2: 103,
    y2: 119.004,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 107.621,
    y1: 121.078,
    x2: 129.621,
    y2: 112.078,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 134.001,
    y1: 135.956,
    x2: 135.001,
    y2: 114.956,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 140.629,
    y1: 139.075,
    x2: 160.629,
    y2: 131.075,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 112.36,
    y1: 160.236,
    x2: 130.36,
    y2: 145.236,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 105.001,
    y1: 157.04,
    x2: 104.001,
    y2: 129.04,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 99.4453,
    y1: 160.836,
    x2: 87.4453,
    y2: 152.836,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 99.6823,
    y1: 127.735,
    x2: 84.6823,
    y2: 141.735,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 73.9701,
    y1: 117.761,
    x2: 79.9701,
    y2: 141.761,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 67.9138,
    y1: 118.41,
    x2: 55.9138,
    y2: 145.41,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 76,
    y1: 151.004,
    x2: 59,
    y2: 151.004,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 50.2151,
    y1: 147.624,
    x2: 35.2151,
    y2: 128.624,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 63.3048,
    y1: 112.956,
    x2: 38.3048,
    y2: 120.956,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 64.2151,
    y1: 105.624,
    x2: 49.2151,
    y2: 86.6236,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 77.3384,
    y1: 106.254,
    x2: 94.3384,
    y2: 91.2541,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 47.2628,
    y1: 78.3282,
    x2: 58.2628,
    y2: 66.3282,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 20.5181,
    y1: 96.1277,
    x2: 40.5181,
    y2: 85.1277,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 17.8682,
    y1: 102.508,
    x2: 25.8682,
    y2: 116.508,
    stroke: "#0071BD",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 84.0039,
    r: 12,
    fill: "#009345"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 108.004,
    r: 5,
    fill: "#1F2188"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 127.004,
    r: 7,
    fill: "#652D93"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 107.004,
    r: 9,
    fill: "#C2272D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 141.004,
    r: 7,
    fill: "#006835"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 123.004,
    r: 7,
    fill: "#F05A24"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 164.004,
    r: 9,
    fill: "#2E3192"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 148.004,
    r: 8,
    fill: "#C2272E"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 110.004,
    r: 10,
    fill: "#23B574"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 150.004,
    r: 7,
    fill: "#8DC53E"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 123.004,
    r: 10,
    fill: "#F8931F"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 83.0039,
    r: 7,
    fill: "#662E91"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 98.0039,
    r: 6,
    fill: "#2E3093"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 56.0039,
    r: 11,
    stroke: "#0071BD",
    strokeWidth: 6
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 56.0039,
    r: 11,
    stroke: "#0071BD",
    strokeWidth: 6
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 83.0039,
    r: 11,
    stroke: "#0071BD",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaninsoftTreeLogo);
export default __webpack_public_path__ + "static/media/caninsoft-tree-logo.d2a70424cf95a9108cde53752469a5ea.svg";
export { ForwardRef as ReactComponent };